export default "__VITE_ASSET__BwYhLXVn__"